module.exports = __webpack_public_path__ + "img/adt.5195376c.png";